<script>
import { RouterView } from "vue-router";
import FaqList from "@/components/FAQ/FaqList.vue";
import MGEXFooter from "@/components/Footer/MGEXFooter.vue";
import DiscordContact from "@/components/2024/Cards/Dsicord/DiscordContact.vue";

export default {
  components: {
    DiscordContact, MGEXFooter, FaqList,
    RouterView,
  },
};
</script>

<template>
  <div>
    <RouterView />
    <div class="container my-5">
      <FaqList />
    </div>
    <div class="container my-5">
      <DiscordContact />
    </div>
    <div class="w-100">
      <MGEXFooter />
    </div>
  </div>

</template>
